"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChimeAudioOutput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _audioVideoHelpers = require("@studio/chime/audioVideo/audioVideoHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ChimeAudioOutput = exports.ChimeAudioOutput = function ChimeAudioOutput(_ref) {
  var _ref$muted = _ref.muted,
    muted = _ref$muted === void 0 ? false : _ref$muted,
    meetingSession = _ref.meetingSession;
  var audioRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (meetingSession) {
      (0, _audioVideoHelpers.bindAudioElement)(meetingSession, audioRef.current);
    }
  }, [meetingSession]);
  return /*#__PURE__*/_react["default"].createElement("audio", {
    ref: audioRef,
    muted: muted
  });
};
ChimeAudioOutput.propTypes = {
  muted: _propTypes["default"].bool,
  meetingSession: _propTypes["default"].object
};